<script lang="ts">
  import css from '../../../../css/comments.pcss.json'
  import cn from 'classnames'
  import SVG from '../../SVG_svelte.svelte'
  import { showModal } from "../../../common/helpers";
  import AddGameModal from "../../AddGameModal";

  export let uploadImage: (file: File) => Promise<void>
  export let toggleBlock: (type: string) => void
  /*export let addBlock: (type: string) => void*/
  export let attachGame: (gameId: number, gameInfo: {
    poster: string,
    status: number,
    url: string,
    name: string,
    releaseDate: string
  }) => void

  let imageInput: HTMLInputElement

  const imageClick = (e: Event) => {
    e.preventDefault()
    imageInput?.click()
  }

  const uploadImages = async (e: Event & {
    currentTarget: HTMLInputElement
  }) => {
    const files = e.currentTarget.files
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i)

      try {
        await uploadImage(file)
      } catch (error) {
        break
      }
    }
  }

  const attachGameClick = () => {
    showModal(AddGameModal, {
      title: 'Прикрепить игру',
      addGame: attachGame
    })
  }
</script>

<div
  class={cn(css['comment-form__textarea-controls'], css['comment-form__textarea-controls--open'])}
>
  <button type="button" on:click={attachGameClick}>
    <SVG i="sg-new/gamepad" adaptive/>
  </button>
  <button type="button" title="Вставить изображение" on:click={imageClick}>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.25 4.5H3.75a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75V5.25a.75.75 0 0 0-.75-.75Z"
        stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
      />
      <path
        d="m3 15.75 4.72-4.72a.75.75 0 0 1 1.06 0l4.19 4.19a.75.75 0 0 0 1.06 0l1.94-1.94a.75.75 0 0 1 1.06 0L21 17.25"
        stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
      />
      <path d="M14.63 10.5a1.13 1.13 0 1 0 0-2.25 1.13 1.13 0 0 0 0 2.25Z" fill="currentColor"/>
    </svg>
  </button>
  <button
    type="button" title="Вставить цитату" on:mousedown={event => {
        event.preventDefault()
        toggleBlock('quote')
    }}
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.13 13.5H3.75a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 3.75 6h5.63a.75.75 0 0 1 .74.75V15a3.75 3.75 0 0 1-3.74 3.75M21 13.5h-6.38a.75.75 0 0 1-.74-.75v-6a.75.75 0 0 1 .74-.75h5.63a.75.75 0 0 1 .75.75V15a3.75 3.75 0 0 1-3.75 3.75"
        stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
      />
    </svg>
  </button>
  <button
    type="button" title="Вставить спойлер" on:mousedown={event => {
        event.preventDefault()
        toggleBlock('spoiler')
    }}
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m4.5 3.75 15 16.5M14.52 14.77a3.75 3.75 0 0 1-5.04-5.54"
        stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
      />
      <path
        d="M6.94 6.43A12.72 12.72 0 0 0 1.5 12s3 6.75 10.5 6.75c1.76.01 3.5-.4 5.06-1.18M19.56 15.85A12.75 12.75 0 0 0 22.5 12s-3-6.75-10.5-6.75c-.65 0-1.3.05-1.94.16"
        stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
      />
      <path
        d="M12.7 8.32a3.75 3.75 0 0 1 3.03 3.33"
        stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
      />
    </svg>
  </button>
  <input
    type="file"
    style="display: none"
    bind:this={imageInput}
    accept="image/jpeg,image/png,image/gif,image/webp"
    multiple
    on:change={uploadImages}
  />
</div>
